export default __webpack_public_path__ + "static/AeonikRegular-41fe6ad932b2342b8c39b1744c104f46.woff2";